import { httpClient } from "./httpClient.js";

/**
 * BFF service for the contact / project inquiry feature.
 * The UI layer imports from here and never touches fetch directly.
 */

/**
 * Sends an inquiry to the backend email endpoint.
 *
 * @param {object} payload
 * @param {string} payload.name
 * @param {string} payload.email
 * @param {string} [payload.company]
 * @param {string} [payload.budget]
 * @param {string} payload.message
 * @param {string} [payload.website] - honeypot; should stay empty
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const sendInquiry = (payload) => {
  return httpClient.post("/inquiry", payload);
};
